/** Fetch the complete archive, even when the CMS caps each response. */
export default async function fetchAllEntries(client, query, isActive = () => true) {
    const items = [];
    const seen = new Set();
    let skip = query.skip || 0;

    while (isActive()) {
        const response = await client.getEntries({ ...query, skip });
        if (!isActive()) return { items: [] };
        const batch = response.items || [];
        if (!Number.isInteger(response.total) || response.total < 0) {
            throw new Error('The CMS did not report the archive total.');
        }
        for (const item of batch) {
            if (!item.sys?.id || seen.has(item.sys.id)) {
                throw new Error('The CMS returned overlapping archive pages.');
            }
            seen.add(item.sys.id);
            items.push(item);
        }
        skip += batch.length;
        if (skip >= response.total) return { items };
        if (batch.length === 0) {
            throw new Error('The CMS returned an incomplete archive.');
        }
    }
    return { items: [] };
}
